React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('home')
{ Snackbar } = require './presentational/snackbar'
ModelCacheListener = require 'app/scripts/views/internal/model-cache-listener'
SidebarState = require 'app/scripts/view-models/sidebar-state'

class UndoDismissSnackbar extends React.Component
  displayName: 'UndoDismissSnackbar'

  constructor: (props) ->
    super props

    this.state =
      isBoardsMenuPinned: SidebarState.getPinSidebar()

  componentDidMount: ->
    @props.modelListener SidebarState, 'change', =>
      @setState isBoardsMenuPinned: SidebarState.getPinSidebar()

  onUndoButtonClick: =>
    { close, undo, idDismiss, shouldShow } = this.props

    if idDismiss && shouldShow
      undo(idDismiss)
      close()

  render: t.renderable ->
    { undo, close, boardName, idDismiss, cardUrl, shouldShow } = @props

    t.tag Snackbar, {
      idSnackbar: idDismiss
      isAnimated: true
      shouldShow: shouldShow
      actionButtonText: t.l('undo')
      onActionButtonClick: @onUndoButtonClick
      onCloseButtonClick: close
      onCloseTimeout: close
      isBoardsMenuPinned: @state.isBoardsMenuPinned
    }, ->
      if boardName && cardUrl
        t.format 'dismissed-to-board', {
          boardName: boardName
          boardUrl: cardUrl
        }

module.exports = ModelCacheListener(UndoDismissSnackbar)
